<div class="wrapper" style="{{style || ''}}">
  <video #target class="video-js vjs-theme-sea" controls playsinline preload="none">
    <ng-content></ng-content>
    <ng-container *ngIf="options.tracks">
      <track *ngFor="let track of options.tracks" [kind]="track.kind" [src]="track.src | safe:'url'" [attr.srclang]="track.srclang" [attr.label]="track.label" [attr.default]="track.default">
    </ng-container>
  </video>
</div>
